import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthMyfileService } from '../services/auth.myfile.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(
        private authService: AuthMyfileService
    ) { }

    intercept( request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> 
    {       
        if(!request.headers.get('Authorization')) { 
            const authModel = this.authService.getAuthFromLocalStorage(); 

            if (authModel) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${authModel.jwtAccessToken?.accessToken}`                            
                    },
                });
            }     
        }
        
        //for multi-part requests clear the content-type as FormData will set its own mutiplart boundries
        if(request.url.toLowerCase().indexOf("uploadstagingfile") <= 0) {
            request = request.clone({
                setHeaders: {                     
                    "Content-Type": "application/json"
                },
            });            
        }

        return next.handle(request);
    }
}
